import { UTM } from '@ads/front-core/api'

export const formatUTM = (utm?: UTM): UTM =>
  Object.keys(utm || {}).reduce<UTM>((acc, utmKey) => {
    return utm?.[utmKey] ? { ...acc, [utmKey]: utm[utmKey] } : acc
  }, {})
